<template>
  <v-container fluid pa-0 pt-12 id="top">
    <sec-legal></sec-legal>
    <sec-request-demo></sec-request-demo>
    <sec-diagonal v-model="this.$diagonal.top"></sec-diagonal>
  </v-container>
</template>

<script>

import SecLegal from '@/components/pages/public/SecLegal';
import SecRequestDemo from '@/components/pages/public/SecRequestDemo';
import SecDiagonal from '@/components/pages/public/SecDiagonal';

export default {
  name: "PageLegalSecurity",
  components: {
    SecLegal,
    SecRequestDemo, SecDiagonal
  },
  data: () => ({
    // diagonal: {
    //   bottom: 'bottom',
    //   top: 'top',
    // }
  }),
  mounted() {
    // this.checkLoggedIn();
  },
  methods: {
    // checkLoggedIn() {
    //   this.$session.start();
    //   if (!this.$session.has("token")) {
    //     router.push("/auth");
    //   }
    // }
  }
};
</script>

<style>
</style>
